import { Button, Font, PageEmpty, Spacing, Text } from 'zens-storybook'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { StyleSheet } from 'react-native'
import { Link } from 'zens-router'

const styles = StyleSheet.create({
  empty: {
    marginVertical: Spacing.L,
  },
  highlight: {
    fontFamily: Font.medium,
  },
})

interface Props {
  companyId: number
  search?: string
  hasFilter?: boolean
}
const ProductEmpty = (props: Props) => {
  const { companyId, search, hasFilter } = props
  const { t } = useTranslation()

  if (search || hasFilter) {
    return (
      <PageEmpty>
        <Text level={2}>
          {search ? (
            <Trans>
              No results matching{' '}
              <Text level={2} style={styles.highlight}>
                {/* @ts-expect-error Typing of vars in trans not working correctly  */}
                {{ search }}
              </Text>
            </Trans>
          ) : (
            <Trans>No results for the current filter</Trans>
          )}
        </Text>
        <Text style={styles.empty}>
          <Trans>Try adjusting search or filter to find what you're looking for.</Trans>
        </Text>
      </PageEmpty>
    )
  }

  return (
    <PageEmpty>
      <Text level={2}>
        <Trans>There's nothing here yet</Trans>
      </Text>
      <Text style={styles.empty}>
        <Trans>Add your first device and it will be listed here...</Trans>
      </Text>
      <Link href={`/companies/${companyId}/products/add`} asChild>
        <Button title={t('Add device')} left="plus" />
      </Link>
    </PageEmpty>
  )
}

export default ProductEmpty
